import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deliveryApi,
  type DriverPayload,
} from "@/lib/admin-api/delivery";

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

const DRIVERS_KEY = "admin-drivers";

// ---------------------------------------------------------------------------
// Hooks
// ---------------------------------------------------------------------------

export function useDrivers() {
  return useQuery({
    queryKey: [DRIVERS_KEY],
    queryFn: () => deliveryApi.drivers.list(),
    staleTime: 30_000,
  });
}

export function useCreateDriver() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: DriverPayload) => deliveryApi.drivers.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DRIVERS_KEY] });
    },
  });
}

export function useUpdateDriver() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: Partial<DriverPayload>;
    }) => deliveryApi.drivers.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DRIVERS_KEY] });
    },
  });
}

export function useDeleteDriver() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deliveryApi.drivers.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DRIVERS_KEY] });
    },
  });
}
